import { addDocument as createDocumentRequest } from '@/services/documents-service/documents-service';
import {
  CreateDocumentPayload,
  Document,
} from '@/services/documents-service/documents-service.types';
import { openNotification } from '@/utils/notification/notification';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCreateDocument = () => {
  const queryClient = useQueryClient();

  const { mutate: createDocument, isPending } = useMutation<
    Document,
    unknown,
    CreateDocumentPayload
  >({
    mutationFn: (data) => createDocumentRequest(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'], exact: false });
      openNotification({
        message: 'The document was created successfully.',
        type: 'success',
      });
    },
  });

  return { createDocument, isPending };
};
